import { render, staticRenderFns } from "./ComposeMessageModal.vue?vue&type=template&id=553e030c"
import script from "./ComposeMessageModal.vue?vue&type=script&lang=js"
export * from "./ComposeMessageModal.vue?vue&type=script&lang=js"
import style0 from "./ComposeMessageModal.vue?vue&type=style&index=0&id=553e030c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports